export { default as DefaultImage } from './default.png';
export { default as DefaultPodcastImage } from './default-podcast.png';
export { default as DefaultVideoImage } from './default-video.png';
export { default as DefaultGuideImage } from './default-guide.png';
export { default as DefaultAvatar } from './default-avatar.png';
